import {FETCH_PEOPLE_LEVEL_IN_CAMPAIGN, FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS, FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR, RESET_UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  updating: false,
  data: [],
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PEOPLE_LEVEL_IN_CAMPAIGN: {
      return {...state, error: '', loading: true};
    }
    case UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN: {
      return {...state, error: '', updating: true};
    }
    case FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS: {
      return {...state, error: '', payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }, updating: false};
    }
    case FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
